import styled from 'styled-components';
import { transparentize } from 'polished';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
export const Content = styled.div`
  display: flex;
  > div {
    padding: 5px;
    &:first-of-type {
      height: calc(100vh - 137px);
    }
  }
`;

export const RightContent = styled.div`
  padding: 10px;
  margin-left: 10px;
  width: 482px;
  background: ${props => props.theme.cardBackgroud};
  border-radius: 5px;
  section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
  }
  .column {
    display: flex;
    justify-content: space-between;
  }
`;
